import axios from "axios";
import { AxiosConfigHeaders, UserTypes } from "@/configs/AppConfig";
import UserSessionService from "@/lib/UserSessionService";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "tzofs": AxiosConfigHeaders.TZ_OFFSET,
    "tzstr": AxiosConfigHeaders.TZ_STR
  }
});

api.interceptors.request.use(
  (config) => {
    const userKeyObj = UserSessionService.getUserKeyObj()
    const userType = UserSessionService.getUserType()
    const authType = UserSessionService.getAuthType() // potential user type
    if (!!userKeyObj) {
      // the sukey is assigned here
      Object.entries(userKeyObj).forEach(([key, value]) => {
        config.headers[key] = value;
      });
    }
    if (userType != UserTypes.GUEST) {
      config.headers["apikey"] = userType == UserTypes.SYSTEM_USER ? AxiosConfigHeaders.SU_API_KEY : AxiosConfigHeaders.AU_API_KEY;
      config.headers["reqfrom"] = userType == UserTypes.SYSTEM_USER ? AxiosConfigHeaders.SU_REQ_FROM : AxiosConfigHeaders.AU_REQ_FROM;
    }
    else if (!!authType && authType != UserTypes.GUEST) {
      config.headers["apikey"] = authType == UserTypes.SYSTEM_USER ? AxiosConfigHeaders.SU_API_KEY : AxiosConfigHeaders.AU_API_KEY;
      config.headers["reqfrom"] = authType == UserTypes.SYSTEM_USER ? AxiosConfigHeaders.SU_REQ_FROM : AxiosConfigHeaders.AU_REQ_FROM;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api